import { render, staticRenderFns } from "./NotasPacientePTI.vue?vue&type=template&id=23c976b6&scoped=true"
import script from "./NotasPacientePTI.vue?vue&type=script&lang=js"
export * from "./NotasPacientePTI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c976b6",
  null
  
)

export default component.exports